import { Link } from 'react-router-dom';

export default function Footer() {
  const columns = [
    { title: 'Product', links: [
      { to: '/features', label: 'Features' },
      { to: '/pricing', label: 'Pricing' },
      { to: '/system-status', label: 'Status' },
    ]},
    { title: 'Resources', links: [
      { to: '/docs', label: 'Documentation' },
      { to: '/blog', label: 'Blog' },
      { to: '/contact', label: 'Contact Us' },
      { to: '/about', label: 'About Us' },
    ]},
    { title: 'Legal', links: [
      { to: '/legal/terms', label: 'Terms & Conditions' },
      { to: '/legal/privacy', label: 'Privacy Policy' },
      { to: '/legal/refund', label: 'Refund Policy' },
      { to: '/legal/shipping', label: 'Shipping & Delivery' },
      { to: '/legal/cookies', label: 'Cookies' },
    ]},
  ];

  return (
    <footer data-testid="footer" className="border-t border-zinc-800 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-emerald-500 font-mono font-bold text-lg">
              <span className="text-cyan-400">{'>'}</span>_ClawStinger
            </Link>
            <p className="text-zinc-500 text-sm mt-3 leading-relaxed">
              Managed OpenClaw hosting.<br />Deploy your AI assistant in under 60 seconds.
            </p>
          </div>
          {columns.map(col => (
            <div key={col.title}>
              <h4 className="font-mono text-xs text-zinc-400 uppercase tracking-widest mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map(l => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-zinc-500 hover:text-emerald-400 transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-zinc-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600 font-mono">&copy; 2026 ClawStinger. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-zinc-600 hover:text-emerald-400 transition-colors text-xs font-mono">GitHub</a>
            <a href="https://discord.com" target="_blank" rel="noopener noreferrer" className="text-zinc-600 hover:text-emerald-400 transition-colors text-xs font-mono">Discord</a>
            <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="text-zinc-600 hover:text-emerald-400 transition-colors text-xs font-mono">X/Twitter</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
